import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import useTransferencias from "features/transferencia/hooks/useTransferencias";
import moment from "moment";
import { useState } from "react";
import SelectMonthYear from "components/Input/SelectMonthYear";
import PageHeader from "components/Page/PageHeader";
import ModalTransferencia from "components/ModalTransferencia";
import { PermissaoEnum } from "core/resources/enums/permissao";
import TransferenciaTable from "components/TransferenciaTable";
import Container from "components/Container";

function ContentTransferencias() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [filtro, setFiltro] = useState({
    page: 1,
    limit: 10,
  });

  const {
    data: transferencias,
    isLoading,
    isFetching,
    refetch,
  } = useTransferencias({
    dataInicio: selectedDate.startOf("month").format("YYYY-MM-DD"),
    dataFim: selectedDate.endOf("month").format("YYYY-MM-DD"),
    ...filtro,
  });

  const _isLoading = isLoading || isFetching;
  return (
    <>
      <Container>
        <PageHeader
          title="Transferências"
          midComponent={
            <SelectMonthYear
              bg="white"
              value={selectedDate}
              onChange={(date) => date && setSelectedDate(date)}
            />
          }
          onClick={() => setIsOpenModal(true)}
          titleButton={"Nova transferência"}
          permissions={[
            PermissaoEnum.Backoffice.Financeiro.Transferencia.Criar,
          ]}
        />

        <Row gutter={32}>
          <Col sm={24}>
            <Box>
              <Box mt="32px">
                <TransferenciaTable
                  refetch={refetch}
                  isLoading={_isLoading}
                  showHeader={false}
                  transferencias={transferencias}
                  onChangePage={(page, limit) => setFiltro({ page, limit })}
                />
              </Box>
            </Box>
          </Col>
        </Row>
      </Container>

      <ModalTransferencia
        visible={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        refetch={refetch}
      />
    </>
  );
}

export default ContentTransferencias;
